import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckIcon,
  WarningIcon,
  InformationIcon,
  InProgressIcon,
} from 'components/common_v2/icons';
import env from '@beam-australia/react-env';
import { Alert } from '@mui/material';
import TOAST_TYPES from './constants';

export { default as TOAST_TYPES } from './constants';

export const Toast = ({
  type, message, icon, ...rest
}) => {
  // output to console to help with QA
  if (env('NODE_ENV') === 'test') {
    const toastType = type || 'base';
    // eslint-disable-next-line no-console
    console.log(`${toastType.toLowerCase()}-toast text: ${message}`);
  }

  let severity = 'info';
  let alertIcon = icon;
  let testId = 'toast__information';

  switch (type) {
    case TOAST_TYPES.SUCCESS:
      severity = 'success';
      alertIcon = <CheckIcon />;
      testId = 'toast__success';
      break;
    case TOAST_TYPES.IN_PROGRESS:
      severity = 'warning';
      alertIcon = <InProgressIcon />;
      testId = 'toast__warning';
      break;
    case TOAST_TYPES.ERROR:
      severity = 'error';
      alertIcon = <WarningIcon />;
      testId = 'toast__error';
      break;
    case TOAST_TYPES.INFORMATION:
      severity = 'info';
      alertIcon = <InformationIcon />;
      break;
    default:
      break;
  }

  return <Alert data-test-id={testId} severity={severity} icon={alertIcon} variant="filled" {...rest}>{message}</Alert>;
};

Toast.propTypes = {
  icon: PropTypes.node,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.string,
};

Toast.defaultProps = {
  icon: false,
  type: undefined,
};

export default Toast;
